import { createFileRoute } from "@tanstack/react-router";
import { myProfileQueryOptions } from "~/features/myProfile/api";
import { EditProfileTemplate } from "~/features/myProfile/EditProfileTemplate";

export const Route = createFileRoute("/_authenticated/profile/edit")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(myProfileQueryOptions),
  component: EditProfileTemplate,
});
